import { DateTime } from 'luxon';
import { PaymentForm } from '../../interfaces/Checkout/PaymentForm';
import {
  validateCardNumber,
  validateCvc,
  validateEmail,
  validatePhoneNumber,
} from '../../utils/Validation';
import { isTokenValid } from '../../utils/Auth';

export type CheckoutStep = 'profile' | 'address' | 'payment';
export const checkoutSteps: CheckoutStep[] = ['profile', 'address', 'payment'];

export const validateProfile = (form: PaymentForm) => {
  const errors: Record<string, string> = {};
  if (!form.firstName.length) {
    errors.firstName = 'Bu alan gereklidir';
  }
  if (!form.lastName.length) {
    errors.lastName = 'Bu alan gereklidir';
  }
  if (!validateEmail(form.email)) {
    errors.email = 'Lütfen geçerli bir e-posta adresi girin';
  }
  if (!validatePhoneNumber(form.phone)) {
    errors.phone =
      'Telefon numarası 11 karakterden oluşmalı ve başında 0 olmalıdır';
  }

  return errors;
};

export const validateAddress = (form: PaymentForm) => {
  const errors: Record<string, string> = {};

  if (isTokenValid()) {
    if (!form.addressID) {
      errors.addressID = 'Lütfen bir teslimat adresi seçiniz';
    }
    if (!form.billingAddressID) {
      errors.billingAddressID = 'Lütfen bir fatura adresi giriniz';
    }

    return errors;
  }

  if (!form.guestAddress?.address.length) {
    errors.address = 'Bu alan gereklidir';
  }
  if (form.guestAddress?.addressType === 1) {
    if (!form.guestAddress.taxNumber?.length) {
      errors.taxNumber = 'Bu alan gereklidir';
    }
    if (!form.guestAddress.taxOffice?.length) {
      errors.taxOffice = 'Bu alan gereklidir';
    }
  }

  return errors;
};

export const validatePayment = (form: PaymentForm) => {
  if (form.paymentMethod === 'bank_transfer') {
    return {};
  }

  const errors: Record<string, string> = {};

  if (!form.creditCardForm.cardOwner.length) {
    errors.cardOwner = 'Bu alan gereklidir';
  }
  if (!validateCardNumber(form.creditCardForm.cardNumber)) {
    errors.cardNumber = 'Lütfen geçerli bir kart numarası girin';
  }

  const now = DateTime.now();
  const currentMonth = now.month;
  const currentYear = now.year;
  if (
    form.creditCardForm.expiryYear < currentYear ||
    (form.creditCardForm.expiryYear === currentYear &&
      form.creditCardForm.expiryMonth < currentMonth)
  ) {
    errors.expiryYear = 'Lütfen geçerli bir son kullanma tarihi girin';
  }

  if (!validateCvc(form.creditCardForm.cvc)) {
    errors.cvc = 'Geçersiz CVV';
  }

  return errors;
};
